{
    "features-debit-card-atms": {
        "meta": {
            "title": "Save with no-fee ATMs - MAJORITY",
            "description": "Don't pay fees when you withdraw money from any of our 55,000+ ATMs nationwide. Learn more and find an ATM near you."
        },
        "hero": {
            "title": "Save with no-fee ATMs",
            "body": "We offer access to 55,000+ surcharge-free ATMs.",
            "cta": "Get started"
        },
        "no_fees_content_box": {
            "tagline": "VISA® DEBIT CARD**",
            "title": "Stop paying ATM fees",
            "body": "It’s your money. So, why should you pay to withdraw your own cash? Now you don’t have to when you visit one of our 55,000+ in-network ATMs. On average, you can save between $2-$5 every time you make a withdrawal.",
            "cta": "Get started",
            "canvas": "55,000+ fee-free ATMs"
        },
        "free_withdraw_content_box": {
            "tagline": "VISA® DEBIT CARD**",
            "title": "How to do an ATM withdrawal for free",
            "body": "Avoid paying unnecessary fees when you use your MAJORITY Visa® Debit Card to make cash withdrawals from a fee-free ATM near you. With over 55,000 ATMs, there’s plenty to choose from across the country.",
            "cta": "Get started"
        },
        "surcharge_free_content_box": {
            "tagline": "VISA® DEBIT CARD**",
            "title": "Find a surcharge-free ATM near you",
            "body": "Need to find an ATM near you? You can check out our ATM map in the app. With so many in-network ATMs nationwide, there’s always one close by."
        }
    }
}